import { render, staticRenderFns } from "./SidebarLayout.vue?vue&type=template&id=5a42278a&scoped=true&"
import script from "./SidebarLayout.vue?vue&type=script&lang=ts&"
export * from "./SidebarLayout.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarLayout.vue?vue&type=style&index=0&id=5a42278a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a42278a",
  null
  
)

export default component.exports